import type { CSSProperties } from "react";

/** The single authored SVG set for functional controls (R95). Content art uses AssetIcon. */
export const UI_ICON_PATHS = {
  close: "M6 6l12 12M18 6 6 18",
  check: "m5 12 4 4L19 6",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  arrowLeft: "M19 12H5m6-6-6 6 6 6",
  arrowRight: "M5 12h14m-6-6 6 6-6 6",
  arrowUp: "M12 19V5m-6 6 6-6 6 6",
  arrowDown: "M12 5v14m-6-6 6 6 6-6",
  chevronLeft: "m15 5-7 7 7 7",
  chevronRight: "m9 5 7 7-7 7",
  chevronUp: "m5 15 7-7 7 7",
  chevronDown: "m5 9 7 7 7-7",
  expand: "M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5",
  collapse: "M3 8h5V3m8 0v5h5M8 21v-5H3m13 5v-5h5",
  search: "M20 20l-5-5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z",
  lock: "M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5ZM12 14v3",
  unlock: "M7 10V7a5 5 0 0 1 9-3M5 10h14v11H5ZM12 14v3",
  info: "M12 10v7m0-10v.01M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z",
  help: "M9 8a3 3 0 1 1 5 2c-2 1-2 2-2 3m0 3v.01M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z",
  warning: "m12 3 10 18H2ZM12 9v5m0 3v.01",
  clock: "M12 6v6l4 3M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z",
  refresh: "M20 8a9 9 0 0 0-15-3L2 8m0-5v5h5m-3 8a9 9 0 0 0 15 3l3-3m0 5v-5h-5",
  undo: "M3 8h11a7 7 0 0 1 0 14M8 3 3 8l5 5",
  redo: "M21 8H10a7 7 0 0 0 0 14m6-19 5 5-5 5",
  play: "m8 4 13 8-13 8Z",
  pause: "M7 5v14M17 5v14",
  stop: "M5 5h14v14H5Z",
  skip: "m4 5 10 7-10 7Zm15 0v14",
  volume: "M3 9h4l5-5v16l-5-5H3Zm13-1a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14",
  muted: "M3 9h4l5-5v16l-5-5H3Zm13-1 6 8m0-8-6 8",
  music: "M9 18V5l12-2v13M9 9l12-2M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm12-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  settings: "m9 3 1-1h4l1 3 3 1 3-1 2 4-2 2v3l2 2-2 4-3-1-3 1-1 3h-4l-1-3-3-1-3 1-2-4 2-2v-3L1 9l2-4 3 1 3-1ZM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  menu: "M4 6h16M4 12h16M4 18h16",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  home: "m2 11 10-9 10 9M5 9v13h5v-8h4v8h5V9",
  map: "m2 5 6-3 8 3 6-3v17l-6 3-8-3-6 3ZM8 2v17M16 5v17",
  globe: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM2 12h20M12 2a19 19 0 0 0 0 20 19 19 0 0 0 0-20Z",
  people: "M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6 21v-5a6 6 0 0 1 12 0v5M3 7a3 3 0 0 1 2 5m-3 8v-4a4 4 0 0 1 2-3m17-6a3 3 0 0 0-2 5m3 8v-4a4 4 0 0 0-2-3",
  person: "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM4 22v-3a8 8 0 0 1 16 0v3",
  chat: "M3 3h18v14H9l-6 5ZM7 8h10M7 12h6",
  mail: "M2 4h20v16H2Zm0 0 10 9L22 4",
  shop: "M3 10v11h18V10M2 10l3-8h14l3 8M2 10q3 5 5 0 2 5 5 0 2 5 5 0 2 5 5 0M9 21v-7h6v7",
  inventory: "M3 7h18v15H3ZM8 7V3h8v4M3 12h18M9 12v4h6v-4",
  calendar: "M3 5h18v17H3ZM7 2v6M17 2v6M3 10h18M7 14h3m4 0h3m-10 4h3m4 0h3",
  list: "M9 5h12M9 12h12M9 19h12M3 5h.01M3 12h.01M3 19h.01",
  filter: "M3 3h18l-7 8v9l-4 2V11Z",
  sort: "M7 3v18m-4-4 4 4 4-4M14 5h7m-7 7h5m-5 7h3",
  eye: "M2 12q10-16 20 0-10 16-20 0ZM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  edit: "m3 16 13-13 5 5L8 21H3Zm10-10 5 5",
  copy: "M8 8h14v14H8ZM16 4V2H2v14h2",
  trash: "M3 6h18M9 6V2h6v4M5 6l1 16h12l1-16M10 10v8M14 10v8",
  download: "M12 2v13m-5-5 5 5 5-5M3 16v6h18v-6",
  upload: "M12 16V3m-5 5 5-5 5 5M3 16v6h18v-6",
  link: "m9 15 6-6m-7 3-3 3a4 4 0 0 0 6 6l3-3m-4-12 3-3a4 4 0 0 1 6 6l-3 3",
  external: "M14 2h8v8m0-8L10 14M10 4H2v18h18v-8",
  logout: "M9 3H2v18h7M8 12h14m-5-5 5 5-5 5",
  move: "M12 2v20M2 12h20M9 5l3-3 3 3M9 19l3 3 3-3M5 9l-3 3 3 3m14-6 3 3-3 3",
  rotate: "M3 9a9 9 0 1 1 0 6m0-12v6h6",
  repair: "m14 4 1 5 5 1a6 6 0 0 1-8 5l-7 7-3-3 7-7a6 6 0 0 1 5-8Z",
  shield: "m12 2 9 4v6c0 5-6 9-9 10-3-1-9-5-9-10V6Z",
  bell: "M5 17V9a7 7 0 0 1 14 0v8l3 2H2Zm4 5h6",
  location: "M19 9c0 6-7 13-7 13S5 15 5 9a7 7 0 1 1 14 0ZM15 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  send: "m2 3 20 9-20 9 4-9Zm4 9h16",
  bookmark: "M5 2h14v20l-7-5-7 5Z",
  save: "M3 2h14l4 4v16H3ZM7 2v7h10V2M7 22v-9h10v9",
  flag: "M4 22V2m0 1c5-4 10 4 16 0v11c-6 4-11-4-16 0",
  block: "M5 5l14 14M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z",
  attack: "m4 2 8 7 8-7-1 5-6 6 6 6m-6-6-6 6M3 16l5 5m13-5-5 5M4 7l5 5M2 22l4-4m16 4-4-4",
  build: "m3 3 4-1 8 8-3 3Zm11 9 8 8-3 3-8-8M16 2l6 6-5 2-3-3Z",
  gather: "M2 7c8-7 15-5 20 3l-7-4-5 1Zm11-1-9 15-3-2L10 6",
  research: "M8 2h8m-6 0v7L3 21h18L14 9V2M7 15h10",
  dot: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  extinguish: "M10 3h8m-5 0v4m-3 0h6v15h-6ZM16 9h3l3 5M10 13H7l-4 5",
} as const;

export type IconName = keyof typeof UI_ICON_PATHS;

export function Icon({ name, size = "1em", label, className, style }: {
  name: IconName;
  size?: number | string;
  /** Omit inside an already labelled control; provide for a standalone meaningful symbol. */
  label?: string;
  className?: string;
  style?: CSSProperties;
}) {
  return <svg
    data-ui-icon={name}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill={name === "dot" ? "currentColor" : "none"}
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden={label ? undefined : true}
    aria-label={label}
    role={label ? "img" : undefined}
    focusable="false"
    className={className}
    style={{ display: "inline-block", verticalAlign: "-0.18em", flexShrink: 0, ...style }}
  ><path d={UI_ICON_PATHS[name]} /></svg>;
}
